if (!customElements.get('dbtfy-internal-video')) {
  customElements.define(
    'dbtfy-internal-video',
    class InternalVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.playButton = this.querySelector('.dbtfy-internal-video__play');
        this.soundButton = this.querySelector('.dbtfy-internal-video__sound-btn');
        this.timeline = this.querySelector('.dbtfy-internal-video__timeline');
        this.dragging = false;

        const autoplay = this.dataset.autoplay === 'true';
        if (autoplay) {
          this.video.muted = true;
          this.video.setAttribute('muted', '');
          this.video.setAttribute('playsinline', '');
          this.video.play().catch(() => {}); // optional: catch autoplay block
        } else {
          this.video.addEventListener('ended', () => {
            this.classList.remove('dbtfy-internal-video--playing');
            this.classList.add('dbtfy-internal-video--paused');
          });
        }

        // Events
        this.playButton?.addEventListener('click', () => this.toggleVideo());
        this.soundButton?.addEventListener('click', () => this.toggleSound());

        // Timeline events
        if (this.timeline) {
          this.video.addEventListener('timeupdate', () => this.updateTimeline());
          this.timeline.addEventListener('mousedown', (e) => this.startDrag(e));
          this.timeline.addEventListener('touchstart', (e) => this.startDrag(e));
          this.timeline.addEventListener('mousemove', (e) => this.seekVideo(e));
          this.timeline.addEventListener('touchmove', (e) => this.seekVideo(e));
          document.addEventListener('mouseup', () => this.stopDrag());
          document.addEventListener('touchend', () => this.stopDrag());
        }

        // Intersection Observer
        const action = this.dataset.actionOnInactive;
        if (autoplay && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries, action), {
            threshold: 0.05,
          });
          this.observer.observe(this);
        }
      }

      toggleVideo() {
        if (this.video.paused) {
          this.classList.add('dbtfy-internal-video--playing');
          this.classList.remove('dbtfy-internal-video--paused');
          this.video.play();
        } else {
          this.video.pause();
          this.classList.remove('dbtfy-internal-video--playing');
          this.classList.add('dbtfy-internal-video--paused');
        }
      }

      toggleSound() {
        this.video.muted = !this.video.muted;
        this.soundButton?.classList.toggle('muted', this.video.muted);
      }

      onPlay() {
        this.classList.add('dbtfy-internal-video--playing');
        this.classList.remove('dbtfy-internal-video--paused');
      }

      onPause() {
        this.classList.remove('dbtfy-internal-video--playing');
        this.classList.add('dbtfy-internal-video--paused');
      }

      updateTimeline() {
        if (!this.timeline || this.dragging) return;
        const percent = (this.video.currentTime / this.video.duration) * 100;
        this.timeline.style.setProperty('--completed', `${percent}%`);
      }

      startDrag(event) {
        this.dragging = true;
        this.seekVideo(event);
      }

      seekVideo(event) {
        if (!this.dragging) return;
        const rect = this.timeline.getBoundingClientRect();
        const clientX = event.touches ? event.touches[0].clientX : event.clientX;
        const percent = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
        this.video.currentTime = this.video.duration * percent;
      }

      stopDrag() {
        this.dragging = false;
      }

      handleIntersection(entries, action) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.dataset.autoplay === 'true') this.video.play();
          } else {
            if (action === 'pause') {
              this.video.pause();
            } else if (action === 'mute') {
              this.video.muted = true;
              this.soundButton?.classList.add('muted');
            }
          }
        });
      }
    },
  );
}

if (!customElements.get('dbtfy-video')) {
  customElements.define(
    'dbtfy-video',
    class DbtfyVideo extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      }

      init() {
        setTimeout(() => {
          const splideComponent = this.querySelector('splide-component').splideInstance;
          if (!splideComponent) return;
          splideComponent.on('moved', () => {
            const allVideos = this.querySelectorAll('dbtfy-internal-video[data-display-play-button="true"]');

            const currentSlide = splideComponent.Components.Elements.slides[splideComponent.index];
            const currentVideo = currentSlide?.querySelector('dbtfy-internal-video');

            allVideos.forEach((video) => {
              if (video !== currentVideo && video.video) {
                video.video.pause();
                video.classList.remove('dbtfy-internal-video--playing');
              } else {
                video.classList.add('dbtfy-internal-video--playing');
                video.video.play();
              }
            });
          });
        }, 2000);
      }
    },
  );
}
